'use es6';

import http from 'hub-http/clients/apiClient';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
const CMS_OBJECT_TYPE_IDS = {
  BLOG_POST: '0-39',
  SITE_PAGE: '0-38',
  LANDING_PAGE: '0-25'
};
const MAX_RETRIES = 10;
const getRequestDataPayload = (contentId, approvalType) => {
  switch (approvalType) {
    case 'BLOG_POST':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
      return {
        count: 1,
        filterGroups: [{
          filters: [{
            operator: 'EQ',
            property: 'hs_content_id',
            value: contentId
          }]
        }],
        objectTypeId: CMS_OBJECT_TYPE_IDS[approvalType],
        offset: 0,
        query: '',
        requestOptions: {
          properties: ['hs_object_id']
        },
        sorts: []
      };
    case 'KNOWLEDGE_ARTICLE':
    case 'MARKETING_EMAIL':
      return {
        count: 1,
        offset: 0,
        objectTypeId: approvalType,
        requestOptions: {
          properties: ['id']
        },
        filterGroups: [{
          filters: [{
            property: 'hs_origin_asset_id',
            operator: 'EQ',
            value: contentId
          }]
        }]
      };
    default:
      return {};
  }
};
export const fetchObjectIdForContentId = ({
  contentId,
  approvalType,
  onComplete
}) => {
  let retries = 0;
  const data = getRequestDataPayload(contentId, approvalType);
  const attemptSearch = () => {
    http.post('crm-search/search', {
      data
    }).then(response => {
      if (response.results.length) {
        onComplete(response.results[0].objectId);
      } else if (retries < MAX_RETRIES) {
        retries++;
        setTimeout(attemptSearch, 3000);
      }
    }).catch(() => FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "approvals.crmObjectIdFetchError.message"
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "approvals.crmObjectIdFetchError.title"
      }),
      type: 'danger'
    }));
  };
  attemptSearch();
};